import http from '@/utils/http';
const base_path = '/v2/monitorRule';

/**
 * 获取预警配置列表
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getMonitorRuleListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 新建预警配置
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const addMonitorRuleApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 编辑预警配置
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const editMonitorRuleApi = (data, id) => {
  return http.put({
    url: `${base_path}/${id}`,
    data,
  });
};

/**
 * 启用/停用预警配置
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const switchMonitorRuleStatusApi = (data, id) => {
  return http.put({
    url: `${base_path}/${id}`,
    data,
  });
};

/**
 * 删除预警配置
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const delMonitorRuleApi = (id) => {
  return http.delete({
    url: `${base_path}/${id}`,
  });
};
